import * as Yup from 'yup'
import { formErrors } from '../../errors.constants'

export const editAdminFormValidationSchema = Yup.object().shape({
  name: Yup.string().required(formErrors.required),
  surname: Yup.string().required(formErrors.required),
  mail: Yup.string().required(formErrors.required).email(formErrors.email),
})
